var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer",class:_vm.isDark ? 'bg-dark text-light' : ''},[_c('span',[_vm._v("Usuário: "+_vm._s(_vm.usuario))]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Por "),_c('a',{class:_vm.isDark ? 'text-light' : '',attrs:{"href":"http://www.hayhudev.com.br"}},[_vm._v("HayHu Tecnologia")])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4105b934","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 1394
// module chunks = 2